"use client"

import { useState, useEffect } from "react"

import { svgs } from "public/assets/svgs"

const ScrollProgressButton = () => {
  const [scrollProgress, setScrollProgress] = useState(0)
  const [strokeWidth, setStrokeWidth] = useState(1.6)

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  useEffect(() => {
    const updateStrokeWidth = () => {
      setStrokeWidth(window.innerWidth < 768 ? 0.96 : 1.6)
    }

    updateStrokeWidth()
    window.addEventListener("resize", updateStrokeWidth)
    return () => window.removeEventListener("resize", updateStrokeWidth)
  }, [])

  useEffect(() => {
    const updateScrollProgress = () => {
      const scrollTop = window.scrollY
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight
      const progress = scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0
      setScrollProgress(progress)
    }

    window.addEventListener("scroll", updateScrollProgress)
    return () => window.removeEventListener("scroll", updateScrollProgress)
  }, [])

  return (
    <div
      className="fixed bottom-6 right-6 z-50 flex h-12 w-12 cursor-pointer items-center justify-center rounded-full bg-[#0000000A] md:bottom-8 md:right-8 md:h-16 md:w-16 lg:bottom-12 lg:right-12 lg:h-20 lg:w-20"
      onClick={scrollToTop}
      style={{ backdropFilter: "blur(8.8px)" }}
    >
      <svg className="absolute -z-10 h-full w-full rounded-full bg-[#0000000A]" viewBox="0 0 100 100">
        <circle
          className="text-white"
          strokeWidth={strokeWidth}
          fill="transparent"
          r="47.5"
          cx="50"
          cy="50"
          stroke="currentColor"
        />
        <circle
          className="text-[#3F3F3FBF]"
          strokeWidth={strokeWidth}
          fill="transparent"
          r="47.5"
          cx="50"
          cy="50"
          strokeDasharray="298.49"
          strokeDashoffset={(1 - scrollProgress / 100) * 298.49}
          strokeLinecap="round"
          stroke="currentColor"
          transform="rotate(-90 50 50)"
        />
      </svg>

      <div className="block md:hidden">{svgs["vectorIconMobile"]?.({ fill: "none", height: 5.76, width: 11.5 })}</div>
      <div className="hidden md:block lg:hidden">
        {svgs["vectorIconTablet"]?.({ fill: "none", height: 7.68, width: 15.36 })}
      </div>
      <div className="hidden lg:block">{svgs["vectorIcon"]?.({ fill: "none", height: 9.6, width: 19.2 })}</div>
    </div>
  )
}

export default ScrollProgressButton
